import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  // LinearProgress,
  Modal,
  Fade,
  Backdrop,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Divider,
  // TextField,
  // Alert,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import EmailIcon from "@mui/icons-material/Email";
// import PersonIcon from "@mui/icons-material/Person";
// import PhoneIcon from "@mui/icons-material/Phone";
import { CheckCircle } from "@mui/icons-material";
// import SignIn from "../sign-in/SignIn";
import AuthPage from "../sign-in/AuthPage";

// import house1 from "../../pictures/project1.jpg";
// import house2 from "../../pictures/project2.jpg";
// import house3 from "../../pictures/project3.jpg";
// import house4 from "../../pictures/project4.jpg";

// ✅ STEPS DATA - HAND-DRAWN DIAGRAM MATCH [file:61][file:74]
const steps = [
  {
    name: "Consultation",
    content:
      "We begin with a detailed client discussion and site consultation to understand requirements, priorities, budget expectations, and project vision.",
    icon: <HandshakeOutlinedIcon />,
  },
  {
    name: "Planning & Design",
    content:
      "Our team prepares architectural planning, space strategy, and design concepts for client review, refinement, and final approval.",
    icon: <DesignServicesOutlinedIcon />,
  },
  {
    name: "Estimation & BOQ",
    content:
      "We provide a transparent cost estimate and detailed Bill of Quantities based on project scope, specifications, and preferred materials.",
    icon: <CalculateOutlinedIcon />,
  },
  {
    name: "Scheduling",
    content:
      "A structured execution timeline is created with milestone planning, resource coordination, vendor scheduling, and workflow sequencing.",
    icon: <ScheduleOutlinedIcon />,
  },
  {
    name: "Execution",
    content:
      "Construction begins with disciplined site supervision, quality workmanship, safety standards, and consistent progress management.",
    icon: <ConstructionOutlinedIcon />,
  },
  {
    name: "Payments",
    content:
      "Stage-wise payments are processed according to project progress and the mutually agreed payment schedule for complete transparency.",
    icon: <PaymentOutlinedIcon />,
  },
  {
    name: "Quality Check",
    content:
      "Frequent quality inspections are carried out to ensure every stage meets structural standards, finishing quality, and client expectations.",
    icon: <VerifiedOutlinedIcon />,
  },
  {
    name: "Live Tracking",
    content:
      "Clients receive real-time project visibility through regular updates, digital monitoring, and live surveillance support where applicable.",
    icon: <TrackChangesOutlinedIcon />,
  },
  {
    name: "Handover",
    content:
      "The completed project is handed over with final verification, essential documentation, and a professional completion report.",
    icon: <HomeOutlinedIcon />,
  },
];

// const projects = [
//   { title: "Luxury Villa", location: "Chennai", image: house1 },
//   { title: "Modern Duplex", location: "Coimbatore", image: house2 },
//   { title: "Commercial Complex", location: "Madurai", image: house3 },
//   { title: "Premium Residence", location: "Trichy", image: house4 },
// ];

// ✅ UNIFIED BLUE THEME COLORS
const BLUE_THEME = {
  primary: "#0d0651",
  primaryLight: "#1e1b72",
  primaryDark: "#050027",
  accent: "#2196F3",
  accentLight: "#42a5f5",
  accentDark: "#1976d2",
};

const constructionPlansData = [
  {
    category: "Traditional Construction",
    plans: [
      {
        title: "Essential",
        price: "₹2400/sq.ft",
        size: "Any Size",
        features: [
          "Architectural Design & Planning",
          "Structural Design",
          "Bill of Quantity (BOQ)",
          "Foundation & Basement Work",
          "RCC Structural Framework",
          "Brick Masonry",
        ],
        specs: [
          "Foundation & Basement Work",
          "RCC Structural Framework",
          "Brick Masonry",
          "Basic Asian Paints Painting",
          "Vitrified Tiles Flooring",
          "2nd Teak frame: Main door / Flush Bedroom doors",
          "UPVC Windows",
          "Kitchen Granite Platform with SS Sink",
          "Parryware Bathroom Fixtures",
          "Anchor Electrical Wiring & Switches",
          "Ms work at Staircase, Balcony & External Works",
          "Works Excluded from budget: Architectural Design, 3D Elevation Design, Sump, OHT, Septic tank",
        ],
      },
      {
        title: "Premium",
        price: "₹2800/sq.ft",
        size: "Any Size",
        features: [
          "Soil Testing",
          "Architectural Design & Planning",
          "Structural Design",
          "Bill of Quantity (BOQ)",
          "Foundation & Basement Work",
          "RCC Structural Framework",
          "Brick Masonry",
          "Royal Asian Paints Interior & Exterior Painting",
          "Premium Flooring Specifications",
          "Marble & Granite Flooring",
          "2nd Teak frame: Main door / Bedroom doors",
          "2nd Teekwood Windows",
          "Kitchen Granite Platform with Carousel Sinks",
          "Jaquar / Roca Basic model Bathroom Fixtures",
          "Polycab Electrical Wiring & Switches",
          "SS work for Staircase, Balcony & External Works",
          "Optional & Additional Works available",
        ],
        specs: [
          "Soil Testing",
          "Architectural Design & Planning",
          "Structural Design",
          "Bill of Quantity (BOQ)",
          "Foundation & Basement",
          "RCC Structural Framework",
          "Brick Masonry & Partition Walls",
          "Interior & Exterior Painting",
          "Flooring Specifications",
          "Wall Tiling",
          "Doors & Joinery",
          "Windows & Storage Units",
          "Kitchen Platform & Sink",
          "Bathroom & Plumbing Fixtures",
          "Electrical Wiring & Fittings",
          "Staircase & External Works",
         "Works Excluded from budget: Sump, OHT, Septic tank",
        ],
        highlight: true,
      },
      {
        title: "Premium +",
        price: "Cost will be estimated after BOQ",
        size: "Any Size",
        features: [
          "All Premium + Custom Luxury Features",
          "Fully Custom Design",
          "Premium+ Features",
          "Personal Project Manager",
          "Unlimited Revisions",
          "VIP Site Access",
          "End-to-End Project Management",
        ],
        specs: [
          "Complete Design Support",
          "Architectural, Structural & Interior Coordination",
          "End-to-End Project Management",
          "Vendor Coordination & Negotiation",
          "Site Supervision & Quality Checks",
          "Material Planning & Procurement Guidance",
          "Budget Planning & Cost Optimization",
          "Timeline Scheduling & Progress Monitoring",
          "Suitable for luxury homes, unique designs, or client-specific requirements",
          "Custom specifications based on client needs",
        ],
      },
    ],
  },
];

const transparencyPlansData = {
  category: "100% Transparent Pricing",
  plans: [
    {
      title: "Basic",
      price: "₹399/sq.ft",
      size: "Upto 2500 sq.ft",
      features: [
        "Real-time Cost Dashboard",
        "Weekly Progress Reports",
        "No Hidden Charges",
        "Live Photo Updates",
        "Project Report after completion",
        "End-to-End Project Management",
      ],
      specs: [
  "What This Package Offers",
  "Suitable for luxury homes, unique designs, or client-specific requirements",

  "Allows customization of:",
  "Materials",
  "Finishes",
  "Fixtures",
  "Layout and elevation",

  "Complete Design Support",
  "Architectural, Structural & Interior Coordination",
  "Budget Planning & Cost Optimization",
  "Timeline Scheduling & Progress Monitoring",

  "End-to-End Project Management",
  "Full project management support",
  "Vendor Coordination & Negotiation",
  "Material Planning & Procurement Guidance",
  "Site Supervision & Quality Checks",

  "Real-time cost tracking dashboard access",
  "Weekly detailed progress reports",
  "Live photo updates from site",
  "100% transparent pricing - no hidden charges",
  "Comprehensive project completion report",
      ],
      button: "View Details",
    },
    {
      title: "Premium",
      price: "₹299/sq.ft",
      size: "Upto 5000 sq.ft",
      features: [
        "Premium Features",
        "Real-time Cost Dashboard",
        "24/7 Live Surveillance",
        "Project Report after completion",
        "End-to-End Project Management",
      ],
      specs: [
        "What This Package Offers",
  "All Basic features plus premium support",
  "Suitable for luxury homes, unique designs, or client-specific requirements",

  "24/7 live video surveillance access",
  "Dedicated project coordinator",
  "Advanced real-time tracking",
  "Priority material procurement",

  "Allows customization of:",
  "Materials",
  "Finishes",
  "Fixtures",
  "Layout and elevation",

  "Complete Design Support",
  "Architectural, Structural & Interior Coordination",
  "Budget Planning & Cost Optimization",
  "Timeline Scheduling & Progress Monitoring",

  "End-to-End Project Management",
  "Vendor Coordination & Negotiation",
  "Material Planning & Procurement Guidance",
  "Site Supervision & Quality Checks",

  "Real-time cost tracking dashboard access",
  "Weekly detailed progress reports",
  "100% transparent pricing - no hidden charges",
      ],
      highlight: true,
      button: "View Details",
    },
    {
      title: "Premium +",
      price: "₹10-15% to the project value (estimated after BOQ)", 
      size: "Above 5000 sq.ft",
      features: [
        "Fully Custom Design",
        "Premium Features",
        "Personal Project Manager",
        "End-to-End Project Management",
        "VIP Site Access",
      ],
      specs: [
        "Fully customized design & execution",
        "Dedicated personal project manager",
        "VIP site access & priority scheduling",
        "Unlimited design revisions",
        "Premium material selection guidance",
      ],
      button: "Contact Us",
      href: "/contact-us", // Direct link
    },
  ],
};

function ConstructionPlans() {
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [openSignupModal, setOpenSignupModal] = useState(false);
  const [openPlanModal, setOpenPlanModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  // const [signupData, setSignupData] = useState({
  //   name: "",
  //   email: "",
  //   phone: "",
  //   password: "",
  // });
  // const [showPassword, setShowPassword] = useState(false);
  // const [signupError, setSignupError] = useState("");
  // const [isSignedUp, setIsSignedUp] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [expandedPlan, setExpandedPlan] = useState(null);
  const [showSignIn, setShowSignIn] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedPlanDetails, setSelectedPlanDetails] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [userSignedIn, setUserSignedIn] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState({
    traditional: false,
    transparent: false,
  });
  const [expandedSteps, setExpandedSteps] = useState({});

  const checkUserSignedIn = () => {
    return localStorage.getItem("user") !== null;
  };

  const handleViewDetails = (plan) => {
    if (checkUserSignedIn()) {
      // Already signed in, navigate to details page
      sessionStorage.setItem("selectedPlan", JSON.stringify(plan));
      navigate(`/plan-details/${encodeURIComponent(plan.category)}/${encodeURIComponent(plan.title)}`);
    } else {
      // Show signin first
      setSelectedPlanDetails(plan);
      setShowSignIn(true);
    }
  };

  const handleSignInSuccess = () => {
    // User is already authenticated (AuthPage stored the token)
    setUserSignedIn(true);
    setShowSignIn(false);
    setTimeout(() => {
      if (selectedPlanDetails) {
        sessionStorage.setItem("selectedPlan", JSON.stringify(selectedPlanDetails));
        navigate(`/plan-details/${encodeURIComponent(selectedPlanDetails.category)}/${encodeURIComponent(selectedPlanDetails.title)}`);
      }
    }, 800);
  };

  // Toggle Basic to show/hide other cards
  // const toggleBasicExpansion = () => {
  //   setExpandedPlan(expandedPlan === 'Basic' ? null : 'Basic');
  // };

  // const handlePlanClick = (plan) => {
  //   // Check if user exists (mock check)
  //   const user = localStorage.getItem("user");
  //   if (user) {
  //     setSelectedPlan(plan);
  //     setOpenPlanModal(true);
  //   } else {
  //     // New user - show signup first
  //     setSelectedPlan(plan);
  //     setOpenSignupModal(true);
  //   }
  // };

  // const closeSignupModal = () => {
  //   setOpenSignupModal(false);
  //   setSignupData({ name: "", email: "", phone: "", password: "" });
  //   setSignupError("");
  //   setShowPassword(false);
  // };

  const closePlanModal = () => {
    setOpenPlanModal(false);
    setSelectedPlan(null);
  };

  const toggleCategory = (category) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const toggleStep = (stepIndex) => {
    setExpandedSteps((prev) => ({
      ...prev,
      [stepIndex]: !prev[stepIndex],
    }));
  };

  const toggleCategoryOnHover = (category, expand) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [category]: expand,
    }));
  };

  const toggleStepOnHover = (stepIndex, expand) => {
    setExpandedSteps((prev) => ({
      ...prev,
      [stepIndex]: expand,
    }));
  };

  return (
    <>
      {/* ✅ PROCESS SECTION - ACCORDION STYLE */}
      <Box
        sx={{
          py: { xs: 8, sm: 10, md: 14 },
          px: { xs: 2, sm: 3, md: 4 },
          background: `linear-gradient(180deg, ${BLUE_THEME.primaryDark}03, #f4f7ff)`,
          overflow: "hidden",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            textAlign="center"
            fontWeight={900}
            mb={{ xs: 2, sm: 2.5, md: 3 }}
            sx={{
              background: `linear-gradient(45deg, ${BLUE_THEME.primary}, ${BLUE_THEME.accent})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              textShadow: `0 4px 20px ${BLUE_THEME.primaryDark}20`,
              fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3.3rem" },
            }}
          >
            Our Construction Process
          </Typography>

          <Typography
            textAlign="center"
            sx={{
              maxWidth: 900,
              mx: "auto",
              mb: { xs: 6, md: 10 },
              color: `${BLUE_THEME.primaryDark}bb`,
              fontSize: { xs: "0.95rem", sm: "1rem", md: "1.05rem" },
              lineHeight: 1.8,
            }}
          >
            A well-structured end-to-end process that ensures clarity, design precision,
            cost control, execution quality, and confident project delivery.
          </Typography>

          <Box sx={{ maxWidth: 900, mx: "auto" }}>
            {steps.map((step, index) => (
              <Card
                key={index}
                sx={{
                  mb: 2.5,
                  background: expandedSteps[index]
                    ? `linear-gradient(135deg, ${BLUE_THEME.primary} 0%, ${BLUE_THEME.primaryLight} 100%)`
                    : "linear-gradient(145deg, rgba(255,255,255,0.95), rgba(248,250,255,0.9))",
                  borderRadius: 3,
                  overflow: "hidden",
                  border: `2px solid ${expandedSteps[index] ? "transparent" : `${BLUE_THEME.accent}20`}`,
                  boxShadow: expandedSteps[index]
                    ? `0 15px 50px ${BLUE_THEME.primary}40`
                    : "0 8px 25px rgba(13,6,81,0.1)",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  cursor: "pointer",
                }}
              >
                {/* Accordion Header */}
                <Box
                  onClick={() => toggleStep(index)}
                  onMouseEnter={() => toggleStepOnHover(index, true)}
                  onMouseLeave={() => toggleStepOnHover(index, false)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: { xs: 2.5, sm: 3, md: 3.5 },
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background: expandedSteps[index]
                        ? "none"
                        : `${BLUE_THEME.primary}08`,
                    },
                  }}
                >
                  {/* Step Number & Title */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: { xs: 2, md: 3 },
                      flex: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: 44, md: 56 },
                        height: { xs: 44, md: 56 },
                        borderRadius: 2.5,
                        background: expandedSteps[index]
                          ? "rgba(255,255,255,0.25)"
                          : `linear-gradient(135deg, ${BLUE_THEME.primary}, ${BLUE_THEME.primaryLight})`,
                        color: expandedSteps[index] ? "white" : "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 900,
                        fontSize: { xs: "1.1rem", md: "1.3rem" },
                        boxShadow: expandedSteps[index]
                          ? "0 8px 20px rgba(255,255,255,0.3)"
                          : `0 10px 30px ${BLUE_THEME.primary}55`,
                        flexShrink: 0,
                      }}
                    >
                      {index + 1}
                    </Box>

                    <Box sx={{ flex: 1 }}>
                      <Typography
                        sx={{
                          color: expandedSteps[index] ? "white" : BLUE_THEME.primary,
                          fontWeight: 800,
                          fontSize: { xs: "1.1rem", sm: "1.3rem", md: "1.5rem" },
                          lineHeight: 1.3,
                          transition: "all 0.3s ease",
                        }}
                      >
                        {step.name}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Icon & Toggle Arrow */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      ml: 2,
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: 44, md: 52 },
                        height: { xs: 44, md: 52 },
                        borderRadius: 2.5,
                        background: expandedSteps[index]
                          ? "rgba(255,255,255,0.25)"
                          : `linear-gradient(135deg, ${BLUE_THEME.accent}, ${BLUE_THEME.accentLight})`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        boxShadow: expandedSteps[index]
                          ? "0 8px 20px rgba(255,255,255,0.3)"
                          : `0 10px 25px ${BLUE_THEME.accent}45`,
                        flexShrink: 0,
                        fontSize: { xs: "1.3rem", md: "1.5rem" },
                      }}
                    >
                      {step.icon}
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: { xs: 40, md: 48 },
                        height: { xs: 40, md: 48 },
                        background: expandedSteps[index]
                          ? "rgba(255,255,255,0.2)"
                          : `${BLUE_THEME.accent}15`,
                        borderRadius: 2,
                        transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        transform: expandedSteps[index] ? "rotate(180deg)" : "rotate(0deg)",
                      }}
                    >
                      <ExpandMoreIcon
                        sx={{
                          color: expandedSteps[index] ? "white" : BLUE_THEME.accent,
                          fontSize: { xs: 28, md: 32 },
                        }}
                      />
                    </Box>
                  </Box>
                </Box>

                {/* Accordion Content */}
                <Collapse
                  in={expandedSteps[index]}
                  timeout={600}
                  sx={{
                    "& .MuiCollapse-wrapper": {
                      transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      p: { xs: 3, sm: 4, md: 5 },
                      background: "linear-gradient(135deg, rgba(255,255,255,0.15), rgba(248,250,255,0.05))",
                      borderTop: "2px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        color: "rgba(255,255,255,0.95)",
                        lineHeight: 1.8,
                        fontWeight: 500,
                        fontSize: { xs: "0.95rem", sm: "1rem", md: "1.05rem" },
                      }}
                    >
                      {step.content}
                    </Typography>
                  </Box>
                </Collapse>
              </Card>
            ))}
          </Box>
        </Container>
      </Box>


      {/* CONSTRUCTION PLANS - ACCORDION STYLE */}
      <Box
        sx={{
          py: { xs: 8, sm: 10, md: 14 },
          px: { xs: 2, sm: 0 },
          background: "linear-gradient(180deg, #f0f4ff 0%, #0d0651 100%)",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            textAlign="center"
            fontWeight={900}
            mb={{ xs: 6, sm: 8, md: 12 }}
            sx={{
              background: "linear-gradient(45deg, #0d0651, #2196F3)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3.5rem" },
            }}
          >
            Our Construction Plans
          </Typography>

          {/* ACCORDION SECTION - Traditional Construction */}
          <Box sx={{ mb: 4 }}>
            <Card
            
              sx={{
                background: `linear-gradient(135deg, #0d0651 0%, #1e1b72 100%)`,
                borderRadius: 4,
                overflow: "hidden",
                mb: 0,
                boxShadow: "0 15px 50px rgba(13,6,81,0.3)",
                border: "2px solid rgba(33,150,243,0.2)",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              <Box
  onClick={() => toggleCategory("traditional")}
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: { xs: 2.5, sm: 3, md: 4 },
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": { background: "rgba(255,255,255,0.08)" },
  }}
>
                <Box>
                  <Typography
                    variant="h4"
                    fontWeight={900}
                    sx={{
                      color: "white",
                      fontSize: { xs: "1.3rem", sm: "1.8rem", md: "2.2rem" },
                      mb: 1,
                    }}
                  >
                    Traditional Construction
                  </Typography>
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: { xs: "0.85rem", md: "1rem" },
                    }}
                  >
                    Essential • Premium • Premium+
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: { xs: 40, md: 56 },
                    height: { xs: 40, md: 56 },
                    background: "rgba(255,255,255,0.15)",
                    borderRadius: 3,
                    transition: "all 0.4s ease",
                    transform: expandedCategories.traditional
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                  }}
                >
                  <ExpandMoreIcon
                    sx={{
                      color: "white",
                      fontSize: { xs: 28, md: 32 },
                    }}
                  />
                </Box>
              </Box>

              {/* Accordion Content */}
              <Collapse
                in={expandedCategories.traditional}
                timeout={600}
                sx={{
                  "& .MuiCollapse-wrapper": {
                    transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                  },
                }}
              >
                <Box
                  sx={{
                    p: { xs: 3, sm: 4, md: 5 },
                    background: "linear-gradient(180deg, rgba(33,150,243,0.05) 0%, rgba(13,6,81,0.02) 100%)",
                    borderTop: "2px solid rgba(33,150,243,0.2)",
                  }}
                >
                  <Grid
                    container
                    spacing={{ xs: 2, sm: 2.5, md: 3 }}
                    sx={{ alignItems: "stretch" }}
                  >
                    {constructionPlansData[0].plans.map((plan, index) => (
                      <Grid item xs={12} sm={6} md={4} key={plan.title}>
                        <Card
                          sx={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            background:
                              "linear-gradient(145deg, rgba(33,150,243,0.08) 0%, #f8faff 50%)",
                            border: "2px solid rgba(33,150,243,0.15)",
                            borderRadius: 3,
                            position: "relative",
                            transition: "all 0.4s ease",
                            cursor: "pointer",
                            "&:hover": {
                              transform: "translateY(-12px) scale(1.02)",
                              boxShadow: "0 25px 60px rgba(13,6,81,0.25)",
                              borderColor: "rgba(33,150,243,0.3)",
                            },
                          }}
                          onClick={() => handleViewDetails({ ...plan, category: "Traditional Construction" })}
                        >
                          {/* MOST POPULAR Badge */}
                          {plan.highlight && (
                            <Chip
                              label="⭐MOST POPULAR"
                              sx={{
                                position: "absolute",
                                top: 12,
                                right: 16,
                                background: "linear-gradient(45deg, #2196F3, #42a5f5)",
                                color: "white",
                                fontWeight: 700,
                                fontSize: "0.75rem",
                                height: 28,
                              }}
                            />
                          )}

                          <CardContent
                            sx={{
                              flexGrow: 1,
                              textAlign: "center",
                              pt: plan.highlight ? { xs: 5, md: 8 } : { xs: 2, md: 4 },
                              pb: { xs: 1.5, md: 2 },
                              px: { xs: 1, sm: 2 },
                            }}
                          >
                            {/* Plan Title Chip */}
                            <Chip
                              label={plan.title}
                              size="medium"
                              sx={{
                                fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
                                fontWeight: 700,
                                background: "linear-gradient(45deg, #0d0651, #1e1b72)",
                                color: "white",
                                mb: { xs: 2, md: 3 },
                                height: { xs: 40, md: 48 },
                                mx: "auto",
                                boxShadow: "0 4px 15px rgba(13,6,81,0.3)",
                              }}
                            />

                            {/* Price */}
                            <Typography
                              variant="h4"
                              fontWeight={900}
                              sx={{
                                color: "#0d0651",
                                mb: { xs: 1, md: 2 },
                                fontSize: { xs: "1.4rem", sm: "1.8rem", md: "2.2rem" },
                              }}
                            >
                              {plan.price}
                            </Typography>

                            {/* Size */}
                            <Typography
                              variant="subtitle1"
                              sx={{
                                color: "rgba(13,6,81,0.7)",
                                mb: { xs: 2.5, md: 4 },
                                fontWeight: 600,
                                fontSize: { xs: "0.85rem", md: "1rem" },
                              }}
                            >
                              {plan.size}
                            </Typography>

                            {/* Top 5 Features */}
                            <Box sx={{ flexGrow: 1, mb: { xs: 2, md: 3 } }}>
                              {plan.features.slice(0, 5).map((feature, fIdx) => (
                                <Box
                                  key={fIdx}
                                  sx={{
                                    py: { xs: 1, md: 1.5 },
                                    px: { xs: 1, md: 2 },
                                    borderRadius: 2,
                                    background:
                                      "linear-gradient(135deg, rgba(33,150,243,0.04), transparent)",
                                    border: "1px solid rgba(33,150,243,0.1)",
                                    mb: { xs: 1, md: 1.5 },
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <CheckCircle
                                    sx={{
                                      fontSize: { xs: 16, md: 20 },
                                      color: "#2196F3",
                                      flexShrink: 0,
                                    }}
                                  />
                                  <Typography
                                    variant="body2"
                                    fontWeight={500}
                                    sx={{
                                      color: "rgba(13,6,81,0.85)",
                                      fontSize: {
                                        xs: "0.75rem",
                                        sm: "0.825rem",
                                        md: "0.875rem",
                                      },
                                      flex: 1,
                                    }}
                                  >
                                    {feature}
                                  </Typography>
                                </Box>
                              ))}
                            </Box>

                            {/* View Details Button */}
                            <Button
                              variant="contained"
                              fullWidth
                              size="small"
                              onClick={() => handleViewDetails(plan)}
                              sx={{
                                py: { xs: 1.2, md: 1.8 },
                                background:
                                  "linear-gradient(45deg, #0d0651 0%, #1e1b72 100%)",
                                borderRadius: 25,
                                fontSize: { xs: "0.85rem", md: "1rem" },
                                fontWeight: 700,
                                textTransform: "none",
                                boxShadow: "0 8px 25px rgba(13,6,81,0.4)",
                                color: "white",
                                height: { xs: 40, md: 52 },
                                "&:hover": {
                                  background:
                                    "linear-gradient(45deg, #1e1b72 0%, #0d0651 100%)",
                                  transform: "scale(1.05)",
                                  boxShadow: "0 12px 35px rgba(13,6,81,0.6)",
                                },
                              }}
                            >
                              View Details →
                            </Button>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Collapse>
            </Card>
          </Box>

          {/* ACCORDION SECTION - 100% Transparent Pricing */}
          <Box sx={{ mb: 4 }}>
            <Card
              sx={{
                background: `linear-gradient(135deg, #0d0651 0%, #1e1b72 100%)`,
                borderRadius: 4,
                overflow: "hidden",
                mb: 0,
                boxShadow: "0 15px 50px rgba(13,6,81,0.3)",
                border: "2px solid rgba(33,150,243,0.2)",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              <Box
                onClick={() => toggleCategory("transparent")}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: { xs: 2.5, sm: 3, md: 4 },
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "rgba(255,255,255,0.08)",
                  },
                }}
              >
                <Box>
                  <Typography
                    variant="h4"
                    fontWeight={900}
                    sx={{
                      color: "white",
                      fontSize: { xs: "1.3rem", sm: "1.8rem", md: "2.2rem" },
                      mb: 1,
                    }}
                  >
                    100% Transparent Pricing
                  </Typography>
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: { xs: "0.85rem", md: "1rem" },
                    }}
                  >
                    Basic • Premium • Premium+
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: { xs: 40, md: 56 },
                    height: { xs: 40, md: 56 },
                    background: "rgba(255,255,255,0.15)",
                    borderRadius: 3,
                    transition: "all 0.4s ease",
                    transform: expandedCategories.transparent
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                  }}
                >
                  <ExpandMoreIcon
                    sx={{
                      color: "white",
                      fontSize: { xs: 28, md: 32 },
                    }}
                  />
                </Box>
              </Box>

              {/* Accordion Content */}
              <Collapse
                in={expandedCategories.transparent}
                timeout={600}
                sx={{
                  "& .MuiCollapse-wrapper": {
                    transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                  },
                }}
              >
                <Box
                  sx={{
                    p: { xs: 3, sm: 4, md: 5 },
                    background: "linear-gradient(180deg, rgba(33,150,243,0.05) 0%, rgba(13,6,81,0.02) 100%)",
                    borderTop: "2px solid rgba(33,150,243,0.2)",
                  }}
                >
                  <Grid
                    container
                    spacing={{ xs: 2, sm: 2.5, md: 3 }}
                    sx={{ alignItems: "stretch" }}
                  >
                    {transparencyPlansData.plans.map((plan, index) => (
                      <Grid item xs={12} sm={6} md={4} key={plan.title}>
                        <Card
                          sx={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "center",
                            background:
                              "linear-gradient(145deg, rgba(33,150,243,0.08) 0%, #f8faff 50%)",
                            border: "2px solid rgba(33,150,243,0.15)",
                            borderRadius: 3,
                            position: "relative",
                            transition: "all 0.4s ease",
                            cursor: plan.href ? "default" : "pointer",
                            "&:hover": {
                              transform: plan.href
                                ? "none"
                                : "translateY(-12px) scale(1.02)",
                              boxShadow: plan.href
                                ? "0 15px 40px rgba(13,6,81,0.15)"
                                : "0 25px 60px rgba(13,6,81,0.25)",
                              borderColor: plan.href
                                ? "rgba(33,150,243,0.15)"
                                : "rgba(33,150,243,0.3)",
                            },
                          }}
                          onClick={() => !plan.href && handleViewDetails({ ...plan, category: "100% Transparent Pricing" })}
                        >
                          {plan.highlight && (
                            <Chip
                              label="⭐MOST POPULAR"
                              sx={{
                                position: "absolute",
                                top: 12,
                                right: 16,
                                background:
                                  "linear-gradient(45deg, #2196F3, #42a5f5)",
                                color: "white",
                                fontWeight: 700,
                                fontSize: "0.75rem",
                                height: 28,
                              }}
                            />
                          )}
                          <CardContent
                            sx={{
                              flexGrow: 1,
                              textAlign: "center",
                              pt: plan.highlight ? { xs: 5, md: 8 } : { xs: 2, md: 4 },
                              pb: { xs: 1.5, md: 2 },
                              px: { xs: 1, sm: 2 },
                            }}
                          >
                            <Chip
                              label={plan.title}
                              size="medium"
                              sx={{
                                fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
                                fontWeight: 700,
                                background:
                                  "linear-gradient(45deg, #0d0651, #1e1b72)",
                                color: "white",
                                mb: { xs: 2, md: 3 },
                                height: { xs: 40, md: 48 },
                                mx: "auto",
                                boxShadow: "0 4px 15px rgba(13,6,81,0.3)",
                              }}
                            />
                            <Typography
                              variant="h4"
                              fontWeight={900}
                              sx={{
                                color: "#0d0651",
                                mb: { xs: 1, md: 2 },
                                fontSize: {
                                  xs: "1.4rem",
                                  sm: "1.8rem",
                                  md: "2.2rem",
                                },
                              }}
                            >
                              {plan.price}
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              sx={{
                                color: "rgba(13,6,81,0.7)",
                                mb: { xs: 2.5, md: 4 },
                                fontWeight: 600,
                                fontSize: { xs: "0.85rem", md: "1rem" },
                              }}
                            >
                              {plan.size}
                            </Typography>
                            <Box sx={{ flexGrow: 1, mb: { xs: 2, md: 3 } }}>
                              {plan.features.slice(0, 5).map((feature, fIdx) => (
                                <Box
                                  key={fIdx}
                                  sx={{
                                    py: { xs: 1, md: 1.5 },
                                    px: { xs: 1, md: 2 },
                                    borderRadius: 2,
                                    background:
                                      "linear-gradient(135deg, rgba(33,150,243,0.04), transparent)",
                                    border: "1px solid rgba(33,150,243,0.1)",
                                    mb: { xs: 1, md: 1.5 },
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <CheckCircle
                                    sx={{
                                      fontSize: { xs: 16, md: 20 },
                                      color: "#2196F3",
                                      flexShrink: 0,
                                    }}
                                  />
                                  <Typography
                                    variant="body2"
                                    fontWeight={500}
                                    sx={{
                                      color: "rgba(13,6,81,0.85)",
                                      fontSize: {
                                        xs: "0.75rem",
                                        sm: "0.825rem",
                                        md: "0.875rem",
                                      },
                                      flex: 1,
                                    }}
                                  >
                                    {feature}
                                  </Typography>
                                </Box>
                              ))}
                            </Box>
                            {plan.href ? (
                              <Button
                                variant="contained"
                                fullWidth
                                size="small"
                                component={Link}
                                to={plan.href}
                                sx={{
                                  py: { xs: 1.2, md: 1.8 },
                                  background:
                                    "linear-gradient(45deg, #0d0651 0%, #1e1b72 100%)",
                                  borderRadius: 25,
                                  fontSize: { xs: "0.85rem", md: "1rem" },
                                  fontWeight: 700,
                                  textTransform: "none",
                                  boxShadow: "0 8px 25px rgba(13,6,81,0.4)",
                                  color: "white",
                                  height: { xs: 40, md: 52 },
                                  textDecoration: "none",
                                  "&:hover": {
                                    background:
                                      "linear-gradient(45deg, #1e1b72 0%, #0d0651 100%)",
                                    transform: "scale(1.05)",
                                    boxShadow: "0 12px 35px rgba(13,6,81,0.6)",
                                  },
                                }}
                              >
                                {plan.button}
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                fullWidth
                                size="small"
                                sx={{
                                  py: { xs: 1.2, md: 1.8 },
                                  background:
                                    "linear-gradient(45deg, #0d0651 0%, #1e1b72 100%)",
                                  borderRadius: 25,
                                  fontSize: { xs: "0.85rem", md: "1rem" },
                                  fontWeight: 700,
                                  textTransform: "none",
                                  boxShadow: "0 8px 25px rgba(13,6,81,0.4)",
                                  color: "white",
                                  height: { xs: 40, md: 52 },
                                  "&:hover": {
                                    background:
                                      "linear-gradient(45deg, #1e1b72 0%, #0d0651 100%)",
                                    transform: "scale(1.05)",
                                    boxShadow: "0 12px 35px rgba(13,6,81,0.6)",
                                  },
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewDetails({ ...plan, category: "100% Transparent Pricing" });
                                }}
                              >
                                {plan.button}
                              </Button>
                            )}
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Collapse>
            </Card>
          </Box>

          {/* SignIn Modal */}
          {showSignIn && (
            <Modal
              open={showSignIn}
              onClose={() => setShowSignIn(false)}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1400,
              }}
            >
              <Box
                sx={{
                  outline: "none",
                  maxWidth: { xs: "95%", sm: 500, md: 800 },
                  width: { xs: "calc(100% - 16px)", sm: "90%" },
                  maxHeight: "90vh",
                  overflow: "auto",
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    background: "white",
                    borderRadius: 4,
                    boxShadow: "0 30px 80px rgba(0,0,0,0.4)",
                  }}
                >
                  {/* Close Button */}
                  <IconButton
                    onClick={() => setShowSignIn(false)}
                    sx={{
                      position: "absolute",
                      top: 16,
                      right: 16,
                      zIndex: 10,
                    }}
                  >
                    <CloseIcon />
                  </IconButton>

                  {/* SignIn Component */}
                  <Box
                    sx={{
                      pt: { xs: 3, md: 4 },
                      pb: { xs: 3, md: 4 },
                      px: { xs: 2, md: 0 },
                    }}
                  >
                    <AuthPage onSignInSuccess={handleSignInSuccess} />
                  </Box>
                </Box>
              </Box>
            </Modal>
          )}

          {showDetails && selectedPlanDetails && (
            <Collapse in={showDetails} timeout={600}>
              <Divider
                sx={{ my: 6, borderColor: "rgba(33,150,243,0.3)", height: 2 }}
              />
              <Box
                sx={{
                  p: { xs: 2, sm: 3, md: 6 },
                  background: "rgba(248,250,255,0.95)",
                  borderRadius: 4,
                  border: "2px solid rgba(33,150,243,0.2)",
                  backdropFilter: "blur(20px)",
                  maxWidth: 900,
                  mx: "auto",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: { xs: "flex-start", sm: "center" },
                    mb: { xs: 3, md: 4 },
                    flexDirection: { xs: "column", sm: "row" },
                    gap: { xs: 2, sm: 0 },
                  }}
                >
                  <Typography
                    variant="h4"
                    fontWeight={900}
                    sx={{
                      color: "#0d0651",
                      background: "linear-gradient(45deg, #0d0651, #2196F3)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontSize: { xs: "1.3rem", sm: "1.8rem", md: "2rem" },
                    }}
                  >
                    {selectedPlanDetails.title} – Detailed Specifications
                  </Typography>
                  <IconButton
                    onClick={() => {
                      setShowDetails(false);
                      setSelectedPlanDetails(null);
                    }}
                    sx={{ color: "#0d0651" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Grid container spacing={{ xs: 3, md: 4 }}>
                  {/* Left Column: Price + Size + Quote */}
                  <Grid item xs={12} md={4}>
                    <Box
                      sx={{
                        textAlign: "center",
                        p: { xs: 2, md: 3 },
                        background: "rgba(33,150,243,0.05)",
                        borderRadius: 3,
                        border: "1px solid rgba(33,150,243,0.15)",
                      }}
                    >
                      <Chip
                        label={`${selectedPlanDetails.title} ${selectedPlanDetails.price}`}
                        sx={{
                          fontSize: { xs: "0.95rem", md: "1.2rem" },
                          height: { xs: 40, md: 50 },
                          fontWeight: 800,
                          background:
                            "linear-gradient(45deg, #0d0651, #1e1b72)",
                          color: "white",
                          mb: 3,
                          mx: "auto",
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          color: "rgba(13,6,81,0.8)",
                          mb: 1,
                          fontWeight: 600,
                          fontSize: { xs: "0.9rem", md: "1rem" },
                        }}
                      >
                        <strong>Project Size:</strong>{" "}
                        {selectedPlanDetails.size}
                      </Typography>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          px: { xs: 3, md: 6 },
                          py: { xs: 1, md: 2 },
                          fontSize: { xs: "0.9rem", md: "1.1rem" },
                          background:
                            "linear-gradient(45deg, #0d0651 30%, #2196F3 90%)",
                          borderRadius: 30,
                          fontWeight: 700,
                          boxShadow: "0 12px 40px rgba(13,6,81,0.4)",
                        }}
                      >
                        Get Quote Now
                      </Button>
                    </Box>
                  </Grid>

                  {/* Right Column: Expandable Specs List */}
                  <Grid item xs={12} md={8}>
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      sx={{
                        mb: 3,
                        color: "#2196F3",
                        fontSize: { xs: "1rem", md: "1.1rem" },
                      }}
                    >
                      Complete Specifications (
                      {selectedPlanDetails.specs.length} items)
                    </Typography>
                    <List
                      sx={{
                        maxHeight: 400,
                        overflow: "auto",
                        borderRadius: 2,
                        border: "1px solid rgba(33,150,243,0.1)",
                      }}
                    >
                      {selectedPlanDetails.specs.map((spec, idx) => (
                        <ListItem
                          key={idx}
                          sx={{
                            py: { xs: 1.5, md: 2 },
                            px: { xs: 1, md: 0 },
                            borderBottom: "1px solid rgba(0,0,0,0.05)",
                          }}
                        >
                          <ListItemIcon sx={{ minWidth: 40 }}>
                            <CheckCircle
                              sx={{
                                color: "#2196F3",
                                fontSize: { xs: 20, md: 24 },
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            primary={spec}
                            primaryTypographyProps={{
                              fontWeight: 500,
                              color: "rgba(13,6,81,0.9)",
                              fontSize: { xs: "0.875rem", md: "1rem" },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Grid>
                </Grid>
              </Box>
            </Collapse>
          )}
        </Container>
      </Box>

      {/* RECENT PROJECTS
      <Box
        sx={{
          py: { xs: 8, sm: 10, md: 14 },
          background: `${BLUE_THEME.primaryDark}02`,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            textAlign="center"
            fontWeight={900}
            mb={{ xs: 5, md: 8 }}
            sx={{
              color: BLUE_THEME.primary,
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
            }}
          >
            Recent Projects
          </Typography>
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            {projects.map((project, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    borderRadius: 4,
                    overflow: "hidden",
                    position: "relative",
                    cursor: "pointer",
                    transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                    border: `1px solid ${BLUE_THEME.accent}10`,
                    "&:hover": {
                      transform: "translateY(-12px)",
                      boxShadow: `0 25px 60px ${BLUE_THEME.primaryDark}25`,
                    },
                    "&:hover img": { transform: "scale(1.15)" },
                    "&:hover .overlay": { opacity: 1 },
                  }}
                >
                  <Box sx={{ height: 240, overflow: "hidden" }}>
                    <img
                      src={project.image}
                      alt={project.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transition: "0.6s",
                      }}
                    />
                  </Box>
                  <Box
                    className="overlay"
                    sx={{
                      position: "absolute",
                      top: 120,
                      left: 130,
                      width: "100%",
                      height: "100%",
                      background: `linear-gradient(to bottom, rgba(13,6,81,0.95), rgba(33,150,243,0.1))`,
                      color: "#fff",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      p: 4,
                      opacity: 0,
                      transition: "0.4s",
                    }}
                  >
                    <Typography variant="h6" fontWeight={800} sx={{ mb: 1 }}>
                      {project.title}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 3, opacity: 0.9 }}>
                      {project.location}
                    </Typography>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        background: `linear-gradient(45deg, ${BLUE_THEME.accent}, ${BLUE_THEME.accentLight})`,
                        "&:hover": { background: `${BLUE_THEME.accentDark}` },
                      }}
                    >
                      View Project
                    </Button>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box> */}

      {/* MODAL */}
      <Modal
        open={openPlanModal}
        onClose={closePlanModal}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={openPlanModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              maxWidth: { xs: "95%", sm: 600, md: 800 },
              width: { xs: "calc(100% - 16px)", sm: "90%" },
              maxHeight: "90vh",
              bgcolor: "white",
              borderRadius: 4,
              boxShadow: `0 0 100px ${BLUE_THEME.primaryDark}40`,
              border: `1px solid ${BLUE_THEME.accent}20`,
              p: { xs: 3, sm: 4, md: 6 },
              overflowY: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: { xs: "flex-start", sm: "center" },
                mb: { xs: 3, md: 5 },
              }}
            >
              <Typography
                variant="h4"
                fontWeight={900}
                sx={{
                  color: BLUE_THEME.primary,
                  fontSize: { xs: "1.3rem", sm: "1.8rem", md: "2rem" },
                }}
              >
                {selectedPlan?.title} Plan Details
              </Typography>
              <Button
                onClick={closePlanModal}
                sx={{
                  minWidth: 48,
                  height: 48,
                  background: `${BLUE_THEME.primaryDark}10`,
                  color: BLUE_THEME.primary,
                  "&:hover": { background: `${BLUE_THEME.primary}10` },
                }}
              >
                <CloseIcon />
              </Button>
            </Box>
            <Divider
              sx={{
                mb: { xs: 4, md: 6 },
                borderColor: `${BLUE_THEME.accent}20`,
              }}
            />

            <Grid container spacing={{ xs: 3, md: 6 }}>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="h5"
                  fontWeight={800}
                  mb={3}
                  sx={{
                    color: BLUE_THEME.primary,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Pricing & Coverage
                </Typography>
                <Chip
                  label={`${selectedPlan?.title}: ${selectedPlan?.price}`}
                  sx={{
                    fontSize: { xs: "1rem", md: "1.4rem" },
                    height: { xs: 45, md: 60 },
                    fontWeight: 800,
                    background: `linear-gradient(45deg, ${BLUE_THEME.primary}, ${BLUE_THEME.primaryLight})`,
                    color: "white",
                    mb: 3,
                    borderRadius: 30,
                    boxShadow: `0 10px 30px ${BLUE_THEME.primary}40`,
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    color: `${BLUE_THEME.primaryDark}dd`,
                    mb: 4,
                    fontWeight: 600,
                    fontSize: { xs: "0.95rem", md: "1rem" },
                  }}
                >
                  <strong>Project Size:</strong> {selectedPlan?.size}
                </Typography>

                <Typography
                  variant="h5"
                  fontWeight={800}
                  mb={3}
                  sx={{
                    color: BLUE_THEME.accent,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Included Features:
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: { xs: 1.5, md: 2.5 },
                  }}
                >
                  {selectedPlan?.features?.map((feature, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        py: { xs: 1.5, md: 2 },
                        px: { xs: 2, md: 3 },
                        background: `${BLUE_THEME.accent}05`,
                        borderRadius: 3,
                        border: `1px solid ${BLUE_THEME.accent}15`,
                      }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: BLUE_THEME.accent,
                          mr: 2,
                          fontSize: { xs: 22, md: 26 },
                        }}
                      />
                      <Typography
                        variant="body1"
                        fontWeight={600}
                        sx={{
                          color: BLUE_THEME.primaryDark,
                          fontSize: { xs: "0.9rem", md: "1rem" },
                        }}
                      >
                        {feature}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  variant="h5"
                  fontWeight={800}
                  mb={3}
                  sx={{
                    color: BLUE_THEME.primary,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Package Comparison
                </Typography>
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{
                    borderRadius: 3,
                    border: `1px solid ${BLUE_THEME.accent}15`,
                    background: `${BLUE_THEME.primaryDark}02`,
                    overflowX: { xs: "auto", md: "visible" },
                  }}
                >
                  <Table size="small">
                    <TableHead
                      sx={{
                        background: `linear-gradient(90deg, ${BLUE_THEME.primary}, ${BLUE_THEME.primaryLight})`,
                      }}
                    >
                      <TableRow>
                        <TableCell
                          sx={{
                            color: "white",
                            fontWeight: 700,
                            fontSize: { xs: "0.85rem", md: "1rem" },
                          }}
                        >
                          Features
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            color: "white",
                            fontWeight: 700,
                            fontSize: { xs: "0.85rem", md: "1rem" },
                          }}
                        >
                          {selectedPlan?.title}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedPlan?.features?.map((feature, idx) => (
                        <TableRow
                          key={idx}
                          sx={{
                            "&:hover": {
                              backgroundColor: `${BLUE_THEME.accent}05`,
                            },
                          }}
                        >
                          <TableCell
                            sx={{
                              fontWeight: 500,
                              color: BLUE_THEME.primaryDark,
                              fontSize: { xs: "0.8rem", md: "0.9rem" },
                            }}
                          >
                            {feature}
                          </TableCell>
                          <TableCell align="center">
                            <CheckCircleIcon
                              sx={{
                                color: BLUE_THEME.accent,
                                fontSize: { xs: 20, md: 24 },
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>

            <Box mt={{ xs: 4, md: 6 }} textAlign="center">
              <Button
                variant="contained"
                size="small"
                sx={{
                  background: `linear-gradient(45deg, ${BLUE_THEME.primary} 30%, ${BLUE_THEME.accent} 90%)`,
                  px: { xs: 4, md: 8 },
                  py: { xs: 1.5, md: 2.5 },
                  fontSize: { xs: "1rem", md: "1.3rem" },
                  fontWeight: 800,
                  borderRadius: 35,
                  boxShadow: `0 15px 50px ${BLUE_THEME.primary}50`,
                  textTransform: "none",
                  "&:hover": {
                    boxShadow: `0 25px 70px ${BLUE_THEME.primary}70`,
                    transform: "scale(1.05)",
                  },
                }}
              >
                Get Quote Now
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default ConstructionPlans;
